/**
 * Reddit pixel configuration (#2447).
 *
 * The pixel id comes from the web runtime env (`REACT_APP_REDDIT_PIXEL_ID`,
 * set on the DigitalOcean web component). When it is unset the pixel is off:
 * no script, no `window.rdt`, no network, no errors. Read it only through
 * `getRedditPixelId()` so the switch lives in one place.
 */

export const REDDIT_PIXEL_SCRIPT_SRC = 'https://www.redditstatic.com/ads/pixel.js';

/** Reddit standard conversion event names (rdt('track', <name>)). */
export const REDDIT_EVENTS = {
  PAGE_VISIT: 'PageVisit',
  SIGN_UP: 'SignUp',
  PURCHASE: 'Purchase',
};

/** @returns {string} the pixel id, or '' when the integration is off */
export function getRedditPixelId() {
  const raw = process.env.REACT_APP_REDDIT_PIXEL_ID;
  return typeof raw === 'string' ? raw.trim() : '';
}

export function isRedditPixelConfigured() {
  return getRedditPixelId() !== '';
}
